export enum ServiceOrderPrintMode {
  ASK = "ASK",
  ALWAYS = "ALWAYS",
}
